var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.442,
    height: 18.791
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-copy",
    d: "M11.744 16.442v1.468a.881.881 0 01-.881.881H.881A.881.881 0 010 17.91V4.4a.881.881 0 01.881-.881h2.642v10.868a2.058 2.058 0 002.055 2.055zm0-12.625V0H5.579A.881.881 0 004.7.881v13.506a.881.881 0 00.881.881h9.983a.881.881 0 00.881-.881V4.7h-3.82a.883.883 0 01-.881-.883zm4.44-1.139l-2.42-2.42A.881.881 0 0013.141 0h-.222v3.523h3.523V3.3a.881.881 0 00-.258-.623z",
    fill: "#fff"
  })));
}
export default SvgCopyIcon;